// extracted by mini-css-extract-plugin
export default {"container":"articlesList--container--3YuFK"};